import { render, staticRenderFns } from "./create.vue?vue&type=template&id=6dd82047&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wwwroot\\dealer-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dd82047')) {
      api.createRecord('6dd82047', component.options)
    } else {
      api.reload('6dd82047', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=6dd82047&", function () {
      api.rerender('6dd82047', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/consign/create.vue"
export default component.exports